import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../../../base/BaseComponent'
import {Button, Dropdown, Icon, Input, Menu, Select} from "antd";

const {Option} = Select;

export default class WidthAndHeight extends BaseComponent {
    static defaultProps = {
        onClickCall: () => {

        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            widthVal: "",
            heightVal: "",
            data: "",
            width: "0",
            value:"0",
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    widthChange = (e) => {
        if(e.target.value){
            let num = e.target.value;
            if(num) {
                let value = num.replace(/[^\d]/, '');
                num = value*1;
            }
            this.setState({widthVal: num});
        }else{
            this.setState({widthVal: ''});
        }

    };
    heightChange = (e) => {
        if(e.target.value){
            let num = e.target.value;
            if(num) {
                let value = num.replace(/[^\d]/, '');
                num = value*1;
            }
            this.setState({heightVal: num})
        }else{
            this.setState({heightVal: ''})
        }
    };

    //选择的符号
    handleChange(type, data) {
        this.state[type] = data;
    }

    //确定按钮
    getValue = () => {
        const {width, widthVal, heightVal} = this.state;
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:"widthAndHeightCondition",data:parseInt(width)},{type:"width",data:widthVal},{type:"height",data:heightVal}]);//符号和值
        }
    };

    render() {
        //尺寸
        let size;
        if (this.state.widthVal || this.state.heightVal) {
            let widthCondition;
            switch (this.state.width) {
                case "0": widthCondition = '>';break;
                case "2": widthCondition = '='; break;
                case "1": widthCondition = '<';break;
            }
            size = widthCondition + this.state.widthVal +'x'+ this.state.heightVal
        } else {
            size = '尺寸不限'
        }
        return (
            <Dropdown overlay={this.renderMenu()} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {size}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    renderMenu = () => {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <Menu
                onClick={()=>{
                    this.setState({})
                }}
                ref={ref=>this.menu=ref}
                style={{padding: '16px',fontSize: '12px',marginTop:'7px'}}>
                    <div className={'widthAndHeight'}>
                        <Select defaultValue="0" dropdownStyle={{width: '46px'}}
                                onChange={(value) => this.handleChange('width', value)}>
                            <Option value="0">&gt;</Option>
                            <Option value="2">=</Option>
                            <Option value="1">&lt;</Option>
                        </Select>
                        <Input placeholder="像素" style={{width: '66px', marginLeft: '4px'}}
                               value={this.state.widthVal}
                               maxLength = {5}
                               onChange={(e) => this.widthChange(e)}/>
                        {/*像素连接符调整为x*/}
                        <span> x</span>
                        <Input placeholder="像素" style={{width: '66px', marginLeft: '4px'}}
                               value={this.state.heightVal}
                               maxLength = {5}
                               onChange={(e) => this.heightChange(e)}/>
                        <style>
                            {'.widthAndHeight .ant-select-selection__rendered {margin-left: 8px;}'}
                            {'.widthAndHeight .ant-select-selection-selected-value {margin-right: 7px}'}
                            {`.widthAndHeight .ant-input:focus, .ant-input:hover {border-color:${newSecondSelectColor} !important}`}
                        </style>
                    </div>
                    <div style={{
                        borderTop: '1px solid rgba(240, 240, 240, 1)', marginTop: '16px',
                        display: 'flex', justifyContent: 'flex-end'
                    }}>
                        <Button type="primary" style={{
                            width: '44px', height: '24px', background: 'rgba(0, 80, 179, 1)',marginLeft:10,
                            color: 'rgba(255, 255, 255, 1)', fontSize: '12px', padding: '0', marginTop: '10px'
                        }}
                                onClick={() => {
                                    this.setState({width:'0', widthVal:'', heightVal:''},()=>{
                                        this.getValue()
                                        this.menu.props.onClick();
                                    });

                                }}>重置</Button>
                        <Button type="primary" style={{
                            width: '44px', height: '24px', background: 'rgba(0, 80, 179, 1)',marginLeft:10,
                            color: 'rgba(255, 255, 255, 1)', fontSize: '12px', padding: '0', marginTop: '10px'
                        }}
                                onClick={() => {
                                    this.getValue()
                                    this.menu.props.onClick();
                                }}>确定</Button>
                    </div>
            </Menu>
        )
    }

}